// 防抖
export function _debounce(fn, delay) {
  var delay = delay || 200;
  var timer;
  return function() {
    var th = this;
    var args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function() {
      timer = null;
      fn.apply(th, args);
    }, delay);
  };
}
/**
 * @desc  函数防抖---“立即执行版本” 和 “非立即执行版本” 的组合版本
 * @param  func 需要执行的函数
 * @param  wait 延迟执行时间（毫秒）
 * @param  immediate---true 表立即执行，false 表非立即执行
 **/
export  function debounce(func,wait,immediate) {
  let timer;

    return function () {
        let context = this;
        let args = arguments;

        if (timer) clearTimeout(timer);
        if (immediate) {
            var callNow = !timer;
            timer = setTimeout(() => {
                timer = null;
            }, wait)
            if (callNow) func.apply(context, args)
        } else {
            timer = setTimeout(function(){
                func.apply(context, args)
            }, wait);
        }
    }

}

// 重置摄像头5分钟限制
export function resetVideoAstrict() {
  sessionStorage.setItem("ezplayDisable", "0");
}

// 判断是否为ie true = ie
export function isIe() {
  if (!!window.ActiveXObject || "ActiveXObject" in window) {
    return true;
    // return false;  //调试
  } else {
    // return true; //调试
    return false;
  }
}

// 返回百分比
export function baifenbi(single, count, useUnit = true) {
  return `${(+single / +count) * 100}${useUnit ? "%" : ""}`;
}

// level转预警等级信息
export function getWarnLevelText(level) {
  let warnInfo = {
    1: {
      text: "黄色预警",
      class: "warn-yellow"
    },
    2: {
      text: "橙色预警",
      class: "warn-orange"
    },
    3: {
      text: "红色预警",
      class: "warn-red"
    }
  };
  return warnInfo[level];
}

// 全部预警类型列表
export function getWarnType(type) {
  let allWarnList = [
    {
      name: "实时预警",
      value: 4,
      includesType: ["", "water", "1"]
    },
    {
      name: "每日预警",
      value: 5,
      includesType: ["", "water", "1"]
    },
    {
      name: "每周预警",
      value: 6,
      includesType: ["", "water", "1"]
    },
    {
      name: "数据真伪",
      value: 2,
      includesType: ["", "water", "0"]
    },
    {
      name: "违法线索",
      value: 1,
      includesType: ["", "water", "0"]
    },
    {
      name: "监测预警",
      value: 3,
      includesType: ["", "water", "air", "1", "0"]
    },
    {
      name: "错峰生产预警",
      value: 10,
      includesType: ["", "air", "1"]
    },
    {
      name: "开关预警",
      value: 11,
      includesType: ["", "air", "1"]
    },
    {
      name: "小时预警",
      value: 12,
      includesType: ["", "water", "1"]
    }
  ];
  let info = allWarnList.find(item => item.value === type);
  if (info) {
    return info;
  } else {
    return {
      name:"/"
    };
  }
}

// 日期格式化
export function parseTime(time, pattern) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
			time = parseInt(time)
		} else if (typeof time === 'string') {
			time = time.replace(new RegExp(/-/gm), '/');
		}
		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}




// WEBPACK FOOTER //
// ./src/utils/utils.js